import { render, staticRenderFns } from "./AddressAutocomplete.vue?vue&type=template&id=6b530a3d"
import script from "./AddressAutocomplete.vue?vue&type=script&lang=js"
export * from "./AddressAutocomplete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports